/**
 * Created by Anastasiya on 22.05.2024
 */

const UnitTradeIcon = function () {
    SideBarIcon.call(this, {
        animation: bundles.sidebar.jsons.trade_icon_json,
        targets: "unittradeicon",
        control: "UnitTradeIcon"
    });
};

UnitTradeIcon.prototype = Object.create(SideBarIcon.prototype);
UnitTradeIcon.prototype.constructor = UnitTradeIcon;

UnitTradeIcon.prototype.onPressed = function () {
    cleverapps.focusManager.display({
        focus: "TradeWindow",
        stack: cleverapps.tutorial.checkConditions({ tutorial: Merge3UnitTradeTutorial.NAME }),
        actions: [
            function (f) {
                new TradeWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        ]
    });
};

UnitTradeIcon.prototype.resetState = function () {
    this.available = cleverapps.config.availables.TRADE && cleverapps.user.checkAvailable(cleverapps.config.availables.TRADE);
};